import request from '@/services/base-service';
import { GuideCreatePayload, GuideListPayload } from '@/types/guide';
import type { InternalAxiosRequestConfig } from 'axios';

export const guideApi = {
  list: (payload: GuideListPayload) =>
    request.post('/v1/guide/list', payload, { authorization: true } as InternalAxiosRequestConfig),
  
  // Same payload as list (RequestDTO)
  getHuongDanSuDung: (payload: GuideListPayload) =>
    request.post('/v1/guide/gethuongdansudung', payload, { authorization: true } as InternalAxiosRequestConfig),
  
  getHuongDanByTarget: (payload: GuideListPayload) =>
    request.post('/v1/guide/gethuongdanbytarget', payload, { authorization: true } as InternalAxiosRequestConfig),
};

export const guideAdminApi = {
  list: (payload: GuideListPayload) => {
    let url = '/v1/guide/listadmin';
    const params: string[] = [];
    if (payload.isCommon !== undefined) {
      params.push(`isCommon=${payload.isCommon}`);
    }
    if (payload.selectedTenantId) {
      params.push(`selectedTenantId=${payload.selectedTenantId}`);
    }
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }
    return request.post(url, payload, { authorization: true } as InternalAxiosRequestConfig);
  },
  
  getTenants: () =>
    request.get('/v1/guide/tenants', { authorization: true } as InternalAxiosRequestConfig),
  
  create: (data: GuideCreatePayload, isCommon = false, selectedTenantId?: string) => {
    const params: string[] = [`isCommon=${isCommon}`];
    if (selectedTenantId) {
      params.push(`selectedTenantId=${selectedTenantId}`);
    }
    return request.post(`/v1/guide?${params.join('&')}`, data, { authorization: true } as InternalAxiosRequestConfig);
  },
  
  update: (id: string, data: GuideCreatePayload, isCommon = false, selectedTenantId?: string) => {
    const params: string[] = [`isCommon=${isCommon}`];
    if (selectedTenantId) {
      params.push(`selectedTenantId=${selectedTenantId}`);
    }
    return request.put(`/v1/guide/${id}?${params.join('&')}`, data, { authorization: true } as InternalAxiosRequestConfig);
  },
  
  delete: (id: string, isCommon = false, selectedTenantId?: string) => {
    const params: string[] = [`isCommon=${isCommon}`];
    if (selectedTenantId) {
      params.push(`selectedTenantId=${selectedTenantId}`);
    }
    return request.delete(`/v1/guide/${id}?${params.join('&')}`, { authorization: true } as InternalAxiosRequestConfig);
  },
  
  cloneFromCommon: (targetTenantId: string, ids?: string[]) =>
    request.post(`/v1/guide/clonefromcommon?targetTenantId=${targetTenantId}`, { ids: ids || [] }, { authorization: true } as InternalAxiosRequestConfig),
  
  hasTenantData: (tenantId: string) =>
    request.get(`/v1/guide/hastenantdata?tenantId=${tenantId}`, { authorization: true } as InternalAxiosRequestConfig),
};


